import { useContext } from "react";
import { HostContext } from "./HostContext.js";
const useHost = () => {
  const context = useContext(HostContext);
  if (context === null) {
    throw new Error("useHost must be used within a HostProvider");
  }
  return context;
};
export { useHost };